import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Hiragana from "./pages/Hiragana";
import Converter from "./pages/Converter";
import Analytics from "./Analytics";

function App() {
  return (
    <Router>
      <Analytics />
      <div className="App">
        <div className="content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hiragana" element={<Hiragana />} />
            <Route path="/converter" element={<Converter />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
